import { useState, useImperativeHandle, forwardRef, useRef, React } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

const TimeInput = forwardRef((props, ref) => {
	const { className, placeholder, type } = props;
	const { isDark } = useTheme();
	const theme = isDark ? darkTheme : lightTheme;
	const [value, setValue] = useState('');
	const [changed, setChanged] = useState(false);
	const [changedPlaceholderColor, setChangedPlaceholderColor] = useState(false);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const inputRef = useRef();

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		setDefaultPlaceholder: (val) => {
			setDefaultPlaceholder(val)
			setChangedPlaceholderColor(true);
			inputRef.current.style.borderColor = theme.pointRed;
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = theme.line;
		}
	}));

	function handleClick(e) {
		inputRef.current.style.borderColor = theme.primary;
	}

	function handleChange(e) {
    const regex = /^[0-9:\-\b]{0,11}$/;

		if (regex.test(e.target.value)) {
			if (e.target.value.length === 2)
				setValue(e.target.value.replace(/(\d{2})/, '$1:'));
			else if (e.target.value.length === 5)
				setValue(e.target.value.replace(/(\d{2}):(\d{2})/, '$1:$2-'));
			else if (e.target.value.length === 8)
				setValue(e.target.value.replace(/(\d{2}):(\d{2})-(\d{2})/, '$1:$2-$3:'));
			else
				setValue(e.target.value);
		}
	
		setChanged(true);
	}

	function handleKeyDown(e) {
		if (e.key === 'Backspace') {
			if (value.length === 3 || value.length === 6 || value.length === 9) {
				setValue(value.substring(0, value.length - 1));
			}
		}
	}

	function handleFocus(e) {
		setChangedPlaceholderColor(false);
		if (changed) {
			// do nothing
		} else {
			setValue("");
		}
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = theme.line;
	}

	return <Input
		ref={inputRef}
		clickCount={clickCount}
		type={type}
		placeholder={defaultPlaceholder}
		value={value}
		changedColor={changedPlaceholderColor}
		className={`${className} ${changed ? "changed" : ""}`}
		onClick={handleClick}
		onChange={handleChange}
		onKeyDown={handleKeyDown}
		onFocus={handleFocus}
		onBlur={handleBlur}/>
});

export default TimeInput;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;

  margin: 8px 0 0 0;
  padding: 0px 10px;

  width: 288px;
  height: 30px;

	outline: none;
  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
	color: ${props => props.theme.text};

	::placeholder {
    font-family: NotoSansKR-Regular;
    font-size: 14px;

		color: ${props => props.changedColor ? props.theme.pointRed : props.theme.line};
	}

	&::-webkit-scrollbar {
		width: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: ${props => props.theme.scrollBar};
		border-radius: 4px;
	}

	&::-webkit-scrollbar-track {
		background-color: ${props => props.theme.subBackground};
	}
	
  transition: all 0.3s ease-in-out;
`;